export default __webpack_public_path__ + "static/media/Pageant-media.08cba1cd.png";